import React from 'react';
import { Typography, Grid, Grow, Tooltip, Rating } from '@mui/material';
import { Link } from 'react-router-dom';

import useStylesHook from './Movie.styles.js';

const Movie = ({ movie, index }) => {
  const classes = useStylesHook();
  return (
    // Grid Item, for each individual item
    // Setting Item Columns for each Viewport
    <Grid item xs={12} sm={6} md={4} lg={3} xl={2} className={classes.movie}>

      {/* Animates the items size on screen, and defines the delay of its surging */}
      <Grow in key={index} timeout={(index + 1) * 250}>
        <Link className={classes.links} to={`/movie/${movie.id}`}>
          <img
            alt={movie.title}
            className={classes.image}
            src={movie?.poster_path
              ? `https://image.tmdb.org/t/p/w500/${movie.poster_path}`
              : 'https://picsum.photos/200/300'}
          />
          <Typography className={classes.title} variant="h5">{movie.title}</Typography>
          <Tooltip disableTouchListener title={`${movie.vote_average} / 10`}>
            <div>
              <Rating readOnly value={movie.vote_average / 2} precision={0.1} />
            </div>
          </Tooltip>
        </Link>
      </Grow>
    </Grid>
  );
};

export default Movie;
